const { ccclass, property } = cc._decorator;
export enum EffectName {
    StartBetTips,
    EndBetTips,
    StartVs,
    TipsBet,
    ResultHu,
    ResultLong,
    ResultHe,
    FaPai,
    NaoZhong,
    XiPai,
    JuShu
}

@ccclass
export default class EffectCtr extends cc.Component {
    @property(cc.Animation)
    startBetTips:cc.Animation = null //开始下注

    @property(cc.Animation)
    endBetTips:cc.Animation = null//结束

    @property(cc.Animation)
    startVs:cc.Animation = null //开始VS动画

    @property(cc.Animation)
    tipsBet:cc.Animation = null //开始下注光

    @property(cc.Animation)
    huYing:cc.Animation = null //虎赢

    @property(cc.Animation)
    huYingGuan:cc.Animation = null

    @property(cc.Animation)
    longYing:cc.Animation = null //龙赢

    @property(cc.Animation)
    longYingGuan:cc.Animation = null

    @property(cc.Animation)
    heAim:cc.Animation = null //和

    @property(cc.Animation)
    heGuan:cc.Animation = null

    @property(cc.Animation)
    fapai:cc.Animation = null //发牌

    @property(cc.Animation)
    naozhong:cc.Animation = null //闹钟

    @property(cc.Animation)
    xiPai:cc.Animation = null //洗牌

    @property(cc.Animation)
    juShu:cc.Animation = null //局数


    playEffectAnim(playType:EffectName, callBack:Function = null, cName:string = null, isHide:boolean = false, time:number = 0, loopTimes: number = -1){
        let currentAnimation = null
        switch(playType){
            case EffectName.StartBetTips:
                currentAnimation = this.startBetTips
                break;
            case EffectName.EndBetTips:
                currentAnimation = this.endBetTips
                break;
            case EffectName.StartVs:
                currentAnimation = this.startVs
                break;
            case EffectName.TipsBet:
                currentAnimation = this.tipsBet
                break;
            case EffectName.ResultHu:
                currentAnimation = this.huYing
                this.huYingGuan.node.active = true
                this.huYingGuan.play()
                break;
            case EffectName.ResultLong:
                currentAnimation = this.longYing
                this.longYingGuan.node.active = true
                this.longYingGuan.play()
                break;
            case EffectName.ResultHe:
                currentAnimation = this.heAim
                this.heGuan.node.active = true
                this.heGuan.play()
                break;
            case EffectName.NaoZhong:
                currentAnimation = this.naozhong
                break
            case EffectName.FaPai:
                currentAnimation = this.fapai
                break
            case EffectName.XiPai:
                currentAnimation = this.xiPai
                break
            case EffectName.JuShu:
                currentAnimation = this.juShu    
            default:
                break;
        }
        if (currentAnimation != null){
            currentAnimation.on("stop", function() { if (callBack != null) { 
                callBack()
                currentAnimation.node.active = false
            } }, this)
            currentAnimation.node.active = true
            currentAnimation.play(cName)
        }
    }


    
}